import axios from "axios";
import {
  LoginData,
  UserData,
  HolderData,
} from "../../models/login/login.model";
import { OwnerData } from "../../models/ownerData/ownerData.model";
import { API_ENDPOINTS } from "../../../config/endpoints.config";
import { setHolderDataToLocalStorage } from "../localStorage/localStorage.service";

const loginPost = (loginData: LoginData): Promise<UserData> =>
  axios
    .post(API_ENDPOINTS.USER_LOGIN, loginData, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(({ data }) => data)
    .catch(function (error) {
      throw error;
    });

const getOwnerData = async (
  loginData: LoginData | undefined,
  token: string
): Promise<OwnerData> =>
  axios
    .post(`${API_ENDPOINTS.USER_OWNERDATA}`, loginData, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(({ data }) => {
      const flags = axios.post(
        `${API_ENDPOINTS.USER_OWNERDATA}?holderData=true`,
        loginData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      data.flags = flags;
      return data;
    })
    .catch(function (error) {
      throw error;
    });

const getHolderData = async (
  loginData: LoginData | undefined,
  token: string
): Promise<HolderData> =>
  axios
    .post(`${API_ENDPOINTS.USER_OWNERDATA}?holderData=true`, loginData, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(({ data }) => {
      setHolderDataToLocalStorage(data);
      return data;
    })
    .catch(function (error) {
      throw error;
    });

export { loginPost, getOwnerData, getHolderData };
